export default{
    section:'بخش',
    tendernessWithTheProbeTypesTitle: 'Title',
    sectionStatus: 'Status',
    tendernessWithTheProbeTypesTypes:'Tenderness With The Probe Types',
    editTendernessWithTheProbeTypes:'Edit Tenderness With The Probe Types',
    addTendernessWithTheProbeTypes : 'New Tenderness With The Probe Types ',
}